import { Loading } from 'components';

export default () => (
  <div className="loading-wrap fullpage-loading-wrap">
    <Loading width="10em" color="white" />
  </div>
)
